import { useQuery } from 'react-query';
import { default_first_buy_coupon } from 'src/constants/promotion';
import { PriceEngineService } from 'src/services/PriceEngine';

const first_buy_coupon_query_key = 'FIRST_BUY_COUPON';

const firstOrderDiscountFetcher = PriceEngineService.firstOrderDiscount;

export const useFirstBuyCouponQuery = () => {
  const queryResult = useQuery(
    first_buy_coupon_query_key,
    () => firstOrderDiscountFetcher(),
    { initialData: { code: default_first_buy_coupon }, cacheTime: 0 },
  );

  return queryResult;
};
